import styled from "styled-components";

export const CMPortfolioMetrics = styled.div(props => ({
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gridAutoRows: '1fr',
    gridGap: 30,

    "& > div": {
        margin: 0
    },

    [`@media (min-width: 2000px)`]: {
        "& div":{
            padding:"1vh",
        },
        "& h4":{
            fontSize:"3vh"
        },
        "& div > p":{
            fontSize:"2vh"
        },
        "& button > p":{
            fontSize:"2vh"
        },
        "& button > img":{
            height:"2vh",
            width:"2vh"
        }
      },
    "& .tooltip-content": {
        display:"flex", 
        gap:"5px"
    },

    [`@media${props.theme.breakpoints.lg}`]: {
        display: 'none',
    }

})); 

export const CMMetricsCarousel = styled.div(props => ({
    display: 'none',

    [`@media${props.theme.breakpoints.lg}`]: {
        display: 'block',
    }
})); 